export default "__VITE_ASSET__COkNYKMq__"